<app-breadcrumb
  [title]="'تقرير انضمام شريك او مورد '"
  [items]="['Tables', 'Bootstrap Tables']"
  [active_item]="'Basic'"
>
</app-breadcrumb>

<div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <div class="row">
    <div class="col-12 col-md-6">
        <div class="form-group">
            <label for="">   من تاريخ  </label>
           <input type="date"  class="form-control" [(ngModel)]="ReportsInfo.dateFrom">
        </div>
    </div>
    <div class="col-12 col-md-6">
        <div class="form-group">

            <label for="">    الى تاريخ </label>

          
            <input type="date"  class="form-control"  [(ngModel)]="ReportsInfo.dateTo">
        </div>
   </div>  
  
</div>
<div class="d-flex justify-content-end lign-items-center " >

  <button class="addnew-btn" style="margin-top: 41px;" type="submit" (click)="Viewreports()">عرض التقرير</button>
</div>
    </div>
  </div>
  
</div>

